// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-muted {
  color: #6c757d !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col, .col-12 {
  padding-right: 15px;
  padding-left: 15px;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/cmdb-management/cmdb-management.component.scss"],"names":[],"mappings":"AACA;EACE,yBAAA;AAAF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;AADF","sourcesContent":["// Text utilities\n.text-muted {\n  color: #6c757d !important;\n}\n\n// Spacing utilities\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.col, .col-12 {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
